import { doc, getDoc, setDoc, updateDoc, DocumentReference, Timestamp } from 'firebase/firestore';
import { firestore } from '~/firebase/init';
import getRecentPickMealTime from '~/utils/getRecentPickMealTime';
import checkPickMealTimeValid from '~/utils/checkPickMealTimeValid';

import * as fp from 'lodash/fp';

// types
import { User } from 'firebase/auth';
import { RemotePickMealPointWithId } from '~/types/platform/remotePickMealPoint';
import { OrderType, PaymentType, PreOrderSetting } from '~/types/common';
import { CartStatus, CartType, PlatformCartInFirestore, TaxType } from '~/types/cart';

// TODO: refactor later
export default async function initCart(
  platformId: string,
  auth: User,
  {
    pickMealPointsList,
    preOrderSetting,
    allowOrderTypes,
  }: {
    pickMealPointsList: Array<RemotePickMealPointWithId>;
    preOrderSetting: PreOrderSetting;
    allowOrderTypes: Array<OrderType>;
  },
) {
  const cartRef = doc(
    firestore,
    'platforms',
    platformId,
    'carts',
    auth.uid,
  ) as DocumentReference<PlatformCartInFirestore>;

  const cartDoc = await getDoc<PlatformCartInFirestore>(cartRef);

  const data = cartDoc.data();

  const defaultPickMealPoint = fp.nth(0, pickMealPointsList) || null;

  const cartPickMealPoint = pickMealPointsList.find(({ id }) => fp.eq(id, data?.pickMealPoint?.id));

  const selectedPickMealPoint = cartPickMealPoint || defaultPickMealPoint;

  const recentPickMealTime = selectedPickMealPoint
    ? getRecentPickMealTime(preOrderSetting, selectedPickMealPoint.operatingTime, new Date())
    : { at: null, end: null };

  if (cartDoc.exists() && data) {
    const isValidPickMealTime =
      selectedPickMealPoint &&
      checkPickMealTimeValid(
        {
          pickMealAt: data.pickMealAt ? data.pickMealAt.toDate() : null,
          pickMealEnd: data.pickMealEnd ? data.pickMealEnd.toDate() : null,
        },
        selectedPickMealPoint.operatingTime,
        preOrderSetting,
      );

    await updateDoc(cartRef, {
      orders: cartPickMealPoint && isValidPickMealTime ? data.orders : [],
      pickMealAt: isValidPickMealTime ? data.pickMealAt : recentPickMealTime.at,
      pickMealEnd: isValidPickMealTime ? data.pickMealEnd : recentPickMealTime.end,
      pickMealPoint: selectedPickMealPoint
        ? {
            id: selectedPickMealPoint.id,
            name: selectedPickMealPoint.name,
            geoPoint: selectedPickMealPoint.location.geoPoint,
            address: selectedPickMealPoint.location.address,
          }
        : null,
    });

    return;
  }

  await setDoc<PlatformCartInFirestore>(cartRef, {
    uid: auth.uid,
    cartType: CartType.CART_PERSONAL,
    email: '',
    orders: [],
    orderType: fp.nth(0, allowOrderTypes) || OrderType.PLATFORM_PICKUP_POINT,
    paymentType: PaymentType.NONE,
    pickMealAt: recentPickMealTime.at ? Timestamp.fromDate(recentPickMealTime.at) : null,
    pickMealEnd: recentPickMealTime.end ? Timestamp.fromDate(recentPickMealTime.end) : null,
    pickMealPoint: selectedPickMealPoint
      ? {
          id: selectedPickMealPoint.id,
          name: selectedPickMealPoint.name,
          address: selectedPickMealPoint.location.address,
          geoPoint: selectedPickMealPoint.location.geoPoint,
        }
      : null,
    location: null,
    status: CartStatus.ACTIVE,
    taxType: TaxType.PERSONAL,
    taxInfo: {
      title: '',
      invoice: '',
    },
    campaignId: '',
  });
}
